import React, { FC } from 'react'

import { IconStudentProps } from './IconStudent.types'
import * as Styled from './styles/IconStudent.style'

import { nonThemeableRules } from '../../ruleSet'

const IconStudent: FC<IconStudentProps> = ({
  size = nonThemeableRules.defaultSize as number as IconStudentProps['size'],
  isResponsive = false,
}: IconStudentProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#55071ee3-874a-4ad7-a51b-351591c59c3c__a)' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2'>
          <path
            d='M21.878 7.385c1.184-.602 3.11-.602 4.297 0l17.117 9.145c1.185.6 1.185 1.552 0 2.152l-17.097 9.883c-1.185.6-3.102.6-4.29 0L4.708 19.132c-1.185-.6-1.185-1.55 0-2.152l17.17-9.595Z'
            stroke='#0D0D0D'
          />
          <path
            d='M37 22.322v11.035c0 1.073-.175 1.188-1.148 2.055-.972.868-5.874 5.52-11.852 5.52-5.977 0-11.018-4.682-11.915-5.52-.898-.837-1.085-.982-1.085-2.055'
            stroke='#0D0D0D'
          />
          <path d='M11 40.932V23.295c0-.395.273-.823.873-1.123l9-5.152' stroke='#E60000' />
        </g>
        <defs>
          <clipPath id='55071ee3-874a-4ad7-a51b-351591c59c3c__a'>
            <path d='M0 0h48v48H0z' fill='#fff' />
          </clipPath>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconStudent
